import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { toggleMenu } from '../../store/slices/menu';

import HeaderMenu from '../Menu/HeaderMenu';
import ThemeSwitcher from '../ThemeSwitcher';
import LanguageSwitcher from '../LanguageSwitcher';

import logo from '../../assets/logoPE.png';
import completeLogo from '../../assets/completeLogoPE.png';

import {
  Logo,
  Wrapper,
  Divider,
  MenuIcon,
  CompleteLogo,
  CloseMenuIcon,
  PositioningDivider,
  HeaderMenuContainer,
  MediumAndSmallHeaderContainer,
  LanguageAndThemeSwitcherContainer,
  MediumAndSmallLanguageAndThemeSwitcherContainer
} from './style';

export default function Header() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const open = useSelector((state) => state.menu?.open);

  return (
    <>
      <Wrapper>
        <CompleteLogo src={completeLogo} alt={t('alt.logo')} />

        {open ? (
          <CloseMenuIcon size={30} onClick={() => dispatch(toggleMenu())} />
        ) : (
          <MenuIcon size={30} onClick={() => dispatch(toggleMenu())} />
        )}

        <HeaderMenuContainer>
          <HeaderMenu />
        </HeaderMenuContainer>

        <Logo src={logo} alt={t('alt.logo')} />

        <LanguageAndThemeSwitcherContainer>
          <ThemeSwitcher />
          <LanguageSwitcher />
        </LanguageAndThemeSwitcherContainer>
      </Wrapper>

      {open && (
        <MediumAndSmallHeaderContainer>
          <HeaderMenu />

          <PositioningDivider>
            <Divider />
          </PositioningDivider>

          <MediumAndSmallLanguageAndThemeSwitcherContainer>
            <ThemeSwitcher />
            <LanguageSwitcher />
          </MediumAndSmallLanguageAndThemeSwitcherContainer>
        </MediumAndSmallHeaderContainer>
      )}
    </>
  );
}
